import {
  TreePillsInput,
  TreePillsInputProps,
} from "../../../-components/tree/tree-pills-input"
import { useTranslation } from "react-i18next"
import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"
import { Empty } from "../../../@client/Theasoft_ApiServer__Utils_TreeBase"

interface OwnerTreeSelectProps
  extends Omit<TreePillsInputProps<Empty>, "tree"> {}

export function OwnerGroupTreeSelect(props: OwnerTreeSelectProps) {
  const { t, i18n } = useTranslation("app_server")
  const { data: ownerGroupTree } = useSuspenseQueryGet(
    "/api/OwnerGroup/GetOwnerGroupTree",
    {
      language: i18n.language,
    }
  )

  return (
    <TreePillsInput
      label={t("Owner")}
      placeholder={t("FilterOwners")}
      {...ownerGroupTree}
      {...props}
    />
  )
}
